import { changeView as _changeView } from '../../actions/view';
import { reset as _reset } from '../../actions/authentication';
import { changeLogin as _changeLogin } from '../../actions/login';
import { viewDataSelector } from './selectors';
import { emit as _emit } from '../../actions/events';
import { connect } from 'react-redux';
import { EmailSentViewContainer as Component } from './EmailSentViewContainer';

function mapStateToProps(state) {
  return {
    viewData: viewDataSelector(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeView: function changeView(view) {
      dispatch(_changeView(view));
    },
    reset: function reset() {
      dispatch(_reset());
    },
    changeLogin: function changeLogin(login) {
      dispatch(_changeLogin(login));
    },
    emit: function emit(type, event) {
      dispatch(_emit(type, event));
    }
  };
}

export var EmailSentViewContainer = connect(mapStateToProps, mapDispatchToProps)(Component);